import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import {
  SavedFiltersResponse,
  CreateSavedFilter,
  CreateSavedFilterResponse,
} from './types';

export * from './types';

class SavedFilters extends BaseResource {
  path: string = '';

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = 'v1/filters';
  }

  getSavedFilters(): SavedFiltersResponse {
    return this.getItems();
  }

  createSavedFilter(
    data: Omit<CreateSavedFilter, 'id'>,
  ): CreateSavedFilterResponse {
    return this.send(this.request.post().setBody(data));
  }

  editSavedFilter(data: CreateSavedFilter): CreateSavedFilterResponse {
    return this.send(this.request.put().setBody(data));
  }

  getSavedFilter(id: number): Promise<CreateSavedFilter> {
    return this.send(this.getChildResource(id).request.get());
  }

  removeSavedFilter(id: number) {
    return this.send(this.getChildResource(id).request.del());
  }
}

export default SavedFilters;
